import { render } from "./SquadPopup.vue?vue&type=template&id=5f2b891d&scoped=true"
import script from "./SquadPopup.vue?vue&type=script&lang=js"
export * from "./SquadPopup.vue?vue&type=script&lang=js"

import "./SquadPopup.vue?vue&type=style&index=0&id=5f2b891d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2b891d"]])

export default __exports__